import React, { useState, useEffect } from 'react';

import Grid from '@mui/material/Grid2';

import { 
  Character,
  Spell,
  StoredSpell,
} from "@dndModels";

// import API from "../../../utilities/system_api";
// import DandDCharacterUtilities from "../../../utilities/character_utilities";
// import DataUtilities from '../../../utilities/common_utilities';
import { makeStyles } from "@utilities/theme_utilities";

import StringBox from "@components/input/strings/StringBox";
import ViewSpell from "@dndComponents/display/ViewSpell";
import DeleteButton from "@components/input/buttons/icon_buttons/DeleteButton";

interface Props {
  char: Character;
  stored_spell: StoredSpell;
  spell: Spell;
  onDelete: () => void;
}

// const api = API.getInstance();
// const char_util = DandDCharacterUtilities.getInstance();
// const common_util = DataUtilities.getInstance();

export default function StoredSpellControl({
  char,
  stored_spell,
  spell,
  onDelete
}: Props) {
  const [spell_attack, setSpellAttack] = useState(stored_spell.spell_attack);
  const [spell_dc, setSpellDC] = useState(stored_spell.spell_dc);
  const [spell_mod, setSpellMod] = useState(stored_spell.spell_mod);
  const [expanded, setExpanded] = useState(false);
  const [changing, setChanging] = useState(false);

  useEffect(() => {
    if (changing) {
      char.changed();
      char.subscription_holder.itemsChanged();
      char.subscription_holder.recalculate();
      setChanging(false);
    }
  }, [changing, setChanging, char]);
  
  const useStyles = makeStyles()((theme) => {
    // console.log(theme);
    return ({
      root: {
        backgroundColor: theme.palette.secondary.main
      },
    });
  });

  const { classes, cx } = useStyles();

  return (
    <Grid container spacing={0} direction="row"
      className={cx(classes.root, "padded")}>
      <Grid
        className="clickable"
        onClick={() => {
          setExpanded(!expanded);
        }}
        size={{
          xs: 5
        }}>
        <Grid container spacing={0} direction="row">
          <Grid
            size={{
              xs: 12
            }}>
            <ViewSpell
              spell={spell}
            />
          </Grid>
          { stored_spell.level !== spell.level &&
            <Grid
              className="small_label gray"
              size={{
                xs: 12
              }}>
              Stored at Level {stored_spell.level}
            </Grid>
          }
        </Grid>
      </Grid>
      <Grid
        className="clickable"
        onClick={() => {
          setExpanded(!expanded);
        }}
        size={{
          xs: 5
        }}>
        <Grid container spacing={0} direction="row">
          <Grid
            size={{
              xs: 4
            }}>
            Attack: { spell_attack }
          </Grid>
          <Grid
            size={{
              xs: 4
            }}>
            DC: { spell_dc }
          </Grid>
          <Grid
            size={{
              xs: 4
            }}>
            Mod: { spell_mod }
          </Grid>
          { stored_spell.has_been_cast === 1 &&
            <Grid
              size={{
                xs: 12
              }}>Has Been Cast</Grid>
          }
        </Grid>
      </Grid>
      <Grid
        size={{
          xs: 2
        }}>
        <DeleteButton
          onClick={onDelete}
        />
      </Grid>
      { expanded &&
        <Grid
          className="bordered padded bg_black_transp"
          size={{
            xs: 12
          }}>
          <Grid container spacing={0} direction="row">
            <Grid
              size={{
                xs: 4
              }}>
              <StringBox
                name="Spell Attack"
                value={`${spell_attack}`}
                type="number"
                onBlur={(changed: string) => {
                  setSpellAttack(+changed);
                  stored_spell.spell_attack = +changed;
                  setChanging(true);
                }}
              />
            </Grid>
            <Grid
              size={{
                xs: 4
              }}>
              <StringBox
                name="Spell DC"
                value={`${spell_dc}`}
                type="number"
                onBlur={(changed: string) => {
                  setSpellDC(+changed);
                  stored_spell.spell_dc = +changed;
                  setChanging(true);
                }}
              />
            </Grid>
            <Grid
              size={{
                xs: 4
              }}>
              <StringBox
                name="Spell Modifier"
                value={`${spell_mod}`}
                type="number"
                onBlur={(changed: string) => {
                  setSpellMod(+changed);
                  stored_spell.spell_mod = +changed;
                  setChanging(true);
                }}
              />
            </Grid>
          </Grid>
        </Grid>
      }
    </Grid>
  );
}
